import type { TrackMatchingRowState } from '@/trackMatching/trackMatchingTypes';
import { SOURCE_TYPES } from '@/trackMatching/trackMatchingTypes';

/** One primary save choice per live track (link target or Apply ISRC), stored on the live-track row. */
export type LiveTrackPendingPrimarySave =
  | { kind: 'link'; rawDdexSourceId: string | number }
  | { kind: 'isrc' };

export function liveTrackRowKey(liveTrackId: string | number): string {
  return `${liveTrackId}-${SOURCE_TYPES.LIVE_TRACK}-${liveTrackId}`;
}

export function getPendingPrimarySave(
  liveTrackRow: TrackMatchingRowState | undefined
): LiveTrackPendingPrimarySave | null {
  return liveTrackRow?.pendingPrimarySave ?? null;
}

export function isLinkQueuedForSource(
  liveTrackRow: TrackMatchingRowState | undefined,
  rawDdexSourceId: string | number
): boolean {
  const pending = getPendingPrimarySave(liveTrackRow);
  return pending?.kind === 'link' && pending.rawDdexSourceId === rawDdexSourceId;
}

export function isIsrcQueued(liveTrackRow: TrackMatchingRowState | undefined): boolean {
  return getPendingPrimarySave(liveTrackRow)?.kind === 'isrc';
}

export function clearPendingPrimarySave(liveTrackRow: TrackMatchingRowState): void {
  liveTrackRow.pendingPrimarySave = null;
}

/** True when any artist-name cleanup is queued on the live track row. */
export function isArtistRenameQueued(liveTrackRow: TrackMatchingRowState | undefined): boolean {
  return (liveTrackRow?.pendingArtistRename ?? null) !== null;
}

/** True when an artist-name cleanup is queued specifically from the given match row. */
export function isArtistRenameQueuedForSource(
  liveTrackRow: TrackMatchingRowState | undefined,
  sourceId: string | number
): boolean {
  const pending = liveTrackRow?.pendingArtistRename ?? null;
  return pending !== null && pending.sourceId === sourceId;
}

export function clearPendingArtistRename(liveTrackRow: TrackMatchingRowState): void {
  liveTrackRow.pendingArtistRename = null;
}
